import { Component } from '@angular/core';
import { MessageService } from '../message.service';
import { Message } from '@shared/models/Message';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent {

  constructor(public messageService: MessageService) { }

  close(message: Message) {
    this.messageService.close(message);
  }
}
